import React from "react";
import noChartDataFound from "../../assets/noChartDataFound.svg";

const GraphNoDataFound = ({message}) => {
  return (
    <>
      <div className="dashboardCard mb-40">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="noChartDataFound text-center">
            <div>
              <img
                src={noChartDataFound}
                alt="noChartDataFound"
                className="mb-3"
              />
              <div className="gm fs-20">{message}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GraphNoDataFound;
